import React from 'react';
import style from './additionalInfo.module.scss';
import BaggageIcon from 'acscp/assets/baggage.png';
import WifiIcon from 'acscp/assets/wifi.svg';
import { FormattedMessage } from 'react-intl';
import { BrokerShortDetails, ItineraryAdditionalInformation } from 'acscp/store';
import { withCollapsable } from 'acscp/components/common/collapsable';
import { Title } from 'acscp/components/itinerary/collapsableSections';
import { isEmpty } from 'acscp/components/common/helpers/isEmpty';
import { AdditionalItem } from './additionalItem';
import { ContactInfo } from './contactInfo';

const OtherInformationContent: React.SFC<{
    additionalInformation: ItineraryAdditionalInformation,
    flightManager: BrokerShortDetails | null
}> = ({additionalInformation, flightManager}) => {

    if (isEmpty(additionalInformation)) {
        return null;
    }

    return (
        <div className={style.Container}>
            <div className={style.InnerContainer}>
                <AdditionalItem
                    icon={BaggageIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.otherInfo.baggageAllowance'}
                        defaultMessage={'Baggage Allowance'}
                    />}
                >
                    {additionalInformation.baggage}
                </AdditionalItem>
                <AdditionalItem
                    icon={WifiIcon}
                    label={<FormattedMessage
                        id={'components.itinerary.otherInfo.wifiCharges'}
                        defaultMessage={'Wifi Charges'}
                    />}
                >
                    {additionalInformation.wifiCharges}
                </AdditionalItem>
                <ContactInfo
                    contact={flightManager}
                    title={
                        <FormattedMessage
                            id={'components.itinerary.otherInfo.flightManager'}
                            defaultMessage={'Flight Manager'}
                        />
                    }
                />
            </div>
        </div>
    );
};

const OtherInformation = withCollapsable(
    (
        <Title>
            <FormattedMessage id={'web.components.itinerary.otherInformation'} defaultMessage={'OTHER INFORMATION'} />
        </Title>
    ),
    OtherInformationContent);

export { OtherInformation };
